export type DetectCountryApiResponse = {
  success: boolean;
  data: {
    countryCode: string;
    countryName: string;
    isChina: boolean;
    region?: string;
    city?: string;
  };
};

export type UserGeoFromIpState = {
  countryCode?: string;
  isChina: boolean;
  isLoading: boolean;
  hideGoogleMaps: boolean;
  error: unknown;
};

/**
 * Maps detect-country API / SWR state to map gating flags.
 * Fail open on errors (show Google Maps). Fail closed while loading (do not mount Maps yet).
 * Uses backend `data.isChina` from GET /api/v1/geocoding/detect-country (CU-86c948jd8).
 */
export function resolveUserGeoFromIpState(params: {
  isAuthenticated: boolean;
  isLoading: boolean;
  data?: DetectCountryApiResponse | null;
  error: unknown;
}): UserGeoFromIpState {
  const { isAuthenticated, isLoading, data, error } = params;

  if (!isAuthenticated) {
    return {
      countryCode: undefined,
      isChina: false,
      isLoading: false,
      hideGoogleMaps: false,
      error: null,
    };
  }

  if (isLoading) {
    return {
      countryCode: undefined,
      isChina: false,
      isLoading: true,
      hideGoogleMaps: false,
      error: null,
    };
  }

  if (error || !data?.success || !data.data) {
    return {
      countryCode: undefined,
      isChina: false,
      isLoading: false,
      hideGoogleMaps: false,
      error: error ?? null,
    };
  }

  return {
    countryCode: data.data.countryCode,
    isChina: data.data.isChina,
    isLoading: false,
    hideGoogleMaps: data.data.isChina === true,
    error: null,
  };
}

/** True when Google Maps scripts should not be mounted yet or at all. */
export function shouldBlockGoogleMapsMount(state: Pick<UserGeoFromIpState, 'isLoading' | 'hideGoogleMaps'>): boolean {
  return state.isLoading || state.hideGoogleMaps;
}
